<template>
  <div class="row g-2 justify-content-center my-5">
    <form @submit.prevent="search" id="search" class="col-xxl-7 col-xl-8 col-lg-9">
      <!-- Heading -->
      <h2 class="text-center">Verspätungen vermeiden mit Bahn-Vorhersage</h2>

      <!-- Start Bhf Form-->
      <div class="input-group mb-3">
        <span class="input-group-text fs-4"><i class="icon icon-train"></i></span>
        <auto-suggest
          name="start"
          v-model:value="searchParams.start"
          v-model:is_valid="start_valid"
          :values="stations"
          placeholder="Start (Bahnhof)"
          ariaLabel="Startbahnhof"
        >
        </auto-suggest>
      </div>

      <!-- End Bhf Form -->
      <div class="input-group mb-3 flex-nowrap">
        <span class="input-group-text fs-4"><i class="icon icon-train"></i></span>
        <auto-suggest
          name="destination"
          v-model:value="searchParams.destination"
          v-model:is_valid="destination_valid"
          :values="stations"
          placeholder="Ziel (Bahnhof)"
          ariaLabel="Zielbahnhof"
        >
        </auto-suggest>
        <span class="btn btn-primary fs-4" @click="swap_stations">
          <i class="icon icon-arrow-down-up"></i>
        </span>
      </div>

      <!-- Date Form -->
      <div class="input-group mb-3">
        <span class="input-group-text fs-4"><i class="icon icon-calendar"></i></span>
        <flat-pickr
          v-model="searchParams.date"
          :config="config"
          class="form-control"
          placeholder="Datum und Uhrzeit auswählen"
          name="datetime"
          aria-label="Datum und Uhrzeit"
        >
        </flat-pickr>
        <toggle-switch
          class="align-self-center"
          style="padding: 6px 12px"
          v-model="searchParams.search_for_arrival"
        ></toggle-switch>
      </div>

      <div class="d-flex justify-content-around flex-wrap align-items-center mb-3 gap-3">
        <!-- Only regional checkbox -->
        <check-box
          v-model="searchParams.only_regional"
          id="only_regional"
          label="Nur Nahverkehr"
          :inline="true"
        ></check-box>
        <!-- Bike checkbox -->
        <check-box
          v-model="searchParams.bike"
          id="bike"
          label="Fahrradmitnahme"
          :inline="true"
        ></check-box>
        <!-- Transfer time select -->
        <div class="d-flex align-items-center">
          <label for="transfer_time" class="form-label mb-0 me-2">Umsteigezeit</label>
          <select
            id="transfer_time"
            v-model="searchParams.transfer_time"
            class="form-select form-select-sm"
            style="width: auto"
          >
            <option :value="undefined">Normal</option>
            <option :value="10">Min. 10 Minuten</option>
            <option :value="15">Min. 15 Minuten</option>
            <option :value="20">Min. 20 Minuten</option>
            <option :value="25">Min. 25 Minuten</option>
            <option :value="30">Min. 30 Minuten</option>
            <option :value="35">Min. 35 Minuten</option>
            <option :value="40">Min. 40 Minuten</option>
            <option :value="45">Min. 45 Minuten</option>
          </select>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="text-center">
        <input
          class="btn btn-primary w-100"
          id=""
          name="submit"
          type="submit"
          value="Verbindungen bewerten"
          :disabled="disableSearch"
        />
      </div>

      <div class="text-center mt-3" v-if="false && !Capacitor.isNativePlatform()">
        <div class="card text-bg-warning p-2">
          <div class="card-body">
            Aktuell blockiert die DB viele Anfragen von Bahn-Vorhersage, weshalb die Auskunft nicht
            funktioniert. Stand 23. Juli 2026 funktioniert die
            <NuxtLink class="link-dark" :to="{ path: '/app' }">App </NuxtLink> noch, allerdings ist
            unklar wie lange.
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { German } from 'flatpickr/dist/l10n/de.js'
import { Capacitor } from '@capacitor/core'

import AutoSuggest from './AutoSuggest.vue'
import ToggleSwitch from './ToggleSwitch.vue'
import CheckBox from './CheckBox.vue'

import('flatpickr/dist/themes/dark.css')

const store = useMainStore()
const { stations, searchParams: searchParams, disableSearch } = storeToRefs(store)

const config = ref({
  // Get more from https://flatpickr.js.org/options/
  enableTime: true,
  time_24hr: true,
  dateFormat: 'd.m.Y H:i',
  altFormat: 'd.m.Y H:i',
  locale: German
})

const start_valid = ref(false)
const destination_valid = ref(false)

function search() {
  if (start_valid.value && destination_valid.value) {
    store.fetchStations().then(async () => {
      store.getJourneys()
    })
  }
}
function swap_stations() {
  ;[searchParams.value.start, searchParams.value.destination] = [
    searchParams.value.destination,
    searchParams.value.start
  ]
}

store.fetchStations()
</script>

<style lang="scss">
@import '../assets/scss/flatpickr.scss';
</style>
